// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Secure CV
 * Service Secure CV
 * Version: v.0.1.0
 */
/**
 * The `"null"` literal - matches objects whose corresponding field is not
 * set or was not estimated.
 */
export type NullFilter = typeof NullFilter[keyof typeof NullFilter];


export const NullFilter = {
  null: 'null',
} as const;
